<template>
  <el-card shadow="always" >
    <div slot="header" class="clearfix">
      <span>Добавление события</span>
    </div>

    <el-form :model="form" style="margin-bottom: 25px">
      <el-form-item label="Название" style="margin-right: 15px;">
        <el-input :value="form.name" @input="setName" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="Координаты">
        <el-input :value="form.coord_line" @input="setCoords" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button @click="setInnerVisible()" size="small">Добавить на карте</el-button>
      </el-form-item>
    </el-form>

    <el-divider></el-divider>

    <span class="dialog-footer">
      <el-button type="primary" @click="saveEvent()">Добавить</el-button>
    </span>
  </el-card>
</template>

<script>
  export default {
    name: "NewEvent",
    props: {
      innerVisible: {
        type: Boolean
      },
      form: {
        type: Object
      }
    },
    methods: {
      setName(value){
        this.$emit('setForm', {name: value});
      },
      setCoords(value) {
        this.$emit('setForm', {coord_line: value});
      },
      setInnerVisible() {
        this.$emit('setInnerVisible');
      },
      saveEvent() {
        this.$emit('saveEvent');
      },
    },
  };
</script>

<style>
  .event-add-wrap {
    position: relative;
    height: 0px;
    z-index: 300;
    margin-top: 10px;
  }
  .event-add-wrap__item {
    width: 100%;
    position: absolute;
    bottom: 100px;
    transition: all 400ms linear 0s;
    background-color: #fff;
  }
  .event-add-wrap__item--show {
    bottom: -380px;
  }
</style>
